export const IconUsers = (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.7129 19.4461C10.7129 19.4461 11.4508 16.6987 12.1914 16.4152C13.095 16.0716 15.2622 15.3054 15.2622 15.3054C15.4337 15.2487 15.5657 13.7162 15.5657 13.7162C15.1285 13.297 14.4152 12.6029 14.2438 11.6683C13.275 11.4965 12.6749 9.77844 13.5579 9.7269C12.9356 7.66525 14.1975 5.66201 15.5468 5.49193C15.3376 4.80471 15.4165 3.91992 16.795 3.91992C18.1306 3.91992 18.1306 5.00572 17.9369 5.46616C19.528 5.45413 20.6339 7.71335 19.9035 9.71831C20.7745 9.65302 20.3338 11.2748 19.5074 11.5807C19.3925 12.6115 18.5044 13.4413 17.9352 13.7076C17.9352 13.7076 18.0586 15.2384 18.2386 15.2968C18.2386 15.2968 20.7127 15.941 21.5529 16.4066C22.4564 16.9083 22.9999 18.2089 22.9999 18.2089"
            stroke="#010101"
            strokeWidth="1.21008"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.1997 16.0527C12.5712 15.7566 9.97351 15.0645 9.97351 15.0645C9.6436 15.011 9.65228 13.8711 9.65749 13.4697C10.6681 12.8989 11.1352 11.3934 11.0865 10.8493C11.9061 10.4925 12.4461 8.84251 11.3036 8.96203C12.1318 8.30915 12.1544 3.73008 9.09663 3.32515C6.13088 2.9345 6.60144 4.19209 6.25416 4.23133C4.67752 4.42934 3.71729 6.3523 4.89804 8.95846C3.68256 8.63559 4.40317 10.703 5.02653 11.0045C4.98312 11.8643 5.88257 12.9667 6.49725 13.4662C6.48163 13.8711 6.53372 14.9093 6.18297 15.0609C6.18297 15.0609 3.48462 15.7156 2.76749 16.1865C2.33512 16.4719 2 18.1148 2 18.1148C6.89988 20.3563 16.6996 20.1053 22.9995 18.2177"
            stroke="#010101"
            strokeWidth="1.21008"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const IconShopy = (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 11.25V19.25C20 19.8023 19.5523 20.25 19 20.25H5C4.44772 20.25 4 19.8023 4 19.25V11.25"
            stroke="#010101"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M14 15.25H10V20.25H14V15.25Z" stroke="#010101" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 3.25H15V8.25C15 9.90685 13.6569 11.25 12 11.25C10.3431 11.25 9 9.90685 9 8.25V3.25Z"
            stroke="#010101"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.49999 3.25H8.99999V7.75C8.99999 9.683 7.43299 11.25 5.49999 11.25C4.23578 11.25 3.21094 10.2252 3.21094 8.96095C3.21094 8.64515 3.27628 8.33277 3.40286 8.04345L5.49999 3.25Z"
            stroke="#010101"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 3.25H18.5L20.5971 8.04345C21.1039 9.20166 20.5757 10.5514 19.4175 11.0581C19.1282 11.1847 18.8158 11.25 18.5 11.25C16.567 11.25 15 9.683 15 7.75V3.25Z"
            stroke="#010101"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const IconX1 = (
    <svg width="64" height="12" viewBox="0 0 64 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M39.1009 5.05958C39.7194 5.05958 40.3557 4.55879 40.5215 3.93924L40.8576 2.68333C41.0234 2.0649 40.656 1.56299 40.0376 1.56299H34.6599L34.3372 2.76624H39.6466L39.3553 3.85633H34.0448L33.1172 7.34396H34.2891L34.9008 5.05958H36.4345L38.1072 7.34396H39.8124L38.1408 5.05958H39.1009Z"
            fill="black"
        />
        <path d="M52.026 1.56299L47.4707 7.34396H48.7961L52.277 2.92645L53.3906 7.34396H54.7171L53.2584 1.56299H52.026Z" fill="black" />
        <path
            d="M20.5806 3.85297L20.8719 2.764H26.1778L26.4993 1.56299H21.1452C20.5268 1.56299 19.8904 2.0649 19.7246 2.68333L19.0894 5.05398H24.3953L24.1041 6.14407H18.7981L18.4766 7.34396H23.8307C24.4491 7.34396 25.0855 6.84205 25.2513 6.22362L25.8865 3.85297H20.5806Z"
            fill="black"
        />
        <path
            d="M62.1843 7.34396L63.4335 2.68333C63.5993 2.0649 63.2319 1.56299 62.6134 1.56299H56.8112L55.2617 7.34396H56.465L57.6973 2.73151H59.3711L58.1388 7.34396H59.3073L60.5397 2.73151H62.2135L60.9811 7.34396H62.1843Z"
            fill="black"
        />
        <path d="M27.0156 2.764H29.6742L28.4474 7.34396H29.6182L30.8461 2.764H33.5046L33.8262 1.56299H27.3383L27.0156 2.764Z" fill="black" />
        <path d="M40.4512 7.34353H46.9256L47.246 6.14364H41.9435L42.2359 5.05355H47.5385L47.8611 3.85254H41.3867L40.4512 7.34353Z" fill="black" />
        <path d="M41.6777 2.764H48.1522L48.4738 1.56299H42.0004L41.6777 2.764Z" fill="black" />
        <path d="M14.6836 5.05355H17.918L18.2396 3.85254H15.0063L14.6836 5.05355Z" fill="black" />
        <path d="M7.88827 0H4.62695L7.47599 3.85398L9.55535 2.25413L7.88827 0Z" fill="black" />
        <path d="M11.2115 8.90788H14.4728L11.859 5.37207L9.60938 6.74225L11.2115 8.90788Z" fill="black" />
        <path d="M17.4606 0H13.3635L6.27953 5.43479H7.83009L0 12L13.4139 3.85286H11.8454L17.4606 0Z" fill="url(#paint0_linear_4848_33831)" />
        <defs>
            <linearGradient id="paint0_linear_4848_33831" x1="16.4948" y1="-7.66165e-08" x2="0.0257718" y2="11.9877" gradientUnits="userSpaceOnUse">
                <stop stopColor="#EAC64C" />
                <stop offset="0.554786" stopColor="#C09325" />
                <stop offset="1" stopColor="#AF7D14" />
            </linearGradient>
        </defs>
    </svg>
);

export const IconX2 = (
    <svg width="56" height="12" viewBox="0 0 56 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M32.4793 1.56396H28.6881C27.9464 1.56396 27.1834 2.16559 26.984 2.90838L26.1549 6.00164C25.9566 6.74331 26.3969 7.34606 27.1397 7.34606H30.9299C31.6726 7.34606 32.4356 6.74331 32.635 6.00164L33.4629 2.90838C33.6624 2.16559 33.2221 1.56396 32.4793 1.56396ZM31.4878 5.9165C31.4497 6.04374 31.3358 6.13338 31.2032 6.14057H27.5117C27.4556 6.144 27.4017 6.11864 27.3686 6.07329C27.3355 6.02793 27.3277 5.96883 27.3481 5.9165L28.1323 2.99128C28.1703 2.86441 28.2836 2.77485 28.4158 2.76721H32.1129C32.1688 2.76438 32.2223 2.78988 32.2553 2.83505C32.2882 2.88021 32.2962 2.93895 32.2765 2.99128L31.4878 5.9165Z"
            fill="black"
        />
        <path
            d="M39.948 1.56396H36.1568C35.4151 1.56396 34.6522 2.16559 34.4528 2.90838L33.6237 6.00164C33.4254 6.74331 33.8657 7.34606 34.6085 7.34606H38.3986C39.1414 7.34606 39.9043 6.74331 40.1038 6.00164L40.9317 2.90838C41.1311 2.16559 40.6908 1.56396 39.948 1.56396ZM38.9565 5.9165C38.9184 6.04374 38.8046 6.13338 38.672 6.14057H34.9748C34.9188 6.144 34.8649 6.11864 34.8318 6.07329C34.7986 6.02793 34.7909 5.96883 34.8113 5.9165L35.5955 2.99128C35.6335 2.86441 35.7468 2.77485 35.879 2.76721H39.5761C39.6319 2.76438 39.6855 2.78988 39.7184 2.83505C39.7514 2.88021 39.7594 2.93895 39.7397 2.99128L38.9565 5.9165Z"
            fill="black"
        />
        <path
            d="M25.3857 1.56396H20.0238L19.7011 2.76833H25.0149L24.7247 3.85058H19.4132L18.4766 7.34494H23.8385C24.457 7.34494 25.0933 6.84302 25.2591 6.22459L25.4933 5.35073C25.6255 4.85553 25.3319 4.45445 24.8367 4.45445C25.3319 4.45445 25.8451 4.05225 25.9739 3.55818L26.208 2.68543C26.3716 2.06476 26.0042 1.56396 25.3857 1.56396ZM24.1096 6.13944H19.9644L20.2545 5.0572H24.3998L24.1096 6.13944Z"
            fill="black"
        />
        <path
            d="M42.6863 3.85283L42.9787 2.76385H48.2835L48.6062 1.56396H43.2521C42.6325 1.56396 41.9973 2.06476 41.8315 2.68431L41.1962 5.05495H46.5022L46.2098 6.14505H40.9038L40.5879 7.34494H45.942C46.5604 7.34494 47.1968 6.84302 47.3626 6.22459L47.9978 3.85283H42.6863Z"
            fill="black"
        />
        <path d="M55.9336 1.56299H49.4446L49.123 2.76511H51.7816L50.5537 7.34396H51.7256L52.9524 2.76511H55.6109L55.9336 1.56299Z" fill="black" />
        <path d="M14.6836 5.05467H17.918L18.2396 3.85254H15.0063L14.6836 5.05467Z" fill="black" />
        <path d="M7.88631 0H4.625L7.4729 3.85399L9.55451 2.25413L7.88631 0Z" fill="black" />
        <path d="M11.2115 8.90787H14.4728L11.859 5.37207L9.60938 6.74225L11.2115 8.90787Z" fill="black" />
        <path d="M17.4594 0H13.3634L6.27839 5.43591H7.83007L0 12L13.4127 3.85286H11.8499L17.4594 0Z" fill="url(#paint0_linear_4848_33846)" />
        <defs>
            <linearGradient id="paint0_linear_4848_33846" x1="16.4937" y1="-7.66165e-08" x2="0.0250075" y2="11.9866" gradientUnits="userSpaceOnUse">
                <stop stopColor="#EAC64C" />
                <stop offset="0.554786" stopColor="#C09325" />
                <stop offset="1" stopColor="#AF7D14" />
            </linearGradient>
        </defs>
    </svg>
);

export const IconX3 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="59" height="12" viewBox="0 0 517 108" fill="none">
        <path d="M70.3805 0H41.2705L66.7005 34.4L85.2605 20.12L70.3805 0Z" fill="black" />
        <path d="M100.06 79.5102H129.17L105.84 47.9502L85.7598 60.1802L100.05 79.5102H100.06Z" fill="black" />
        <path d="M155.83 0H119.26L56.0303 48.51H69.8802L-0.00976562 107.11L119.72 34.39H105.77L155.83 0Z" fill="url(#paint0_linear_2337_661)" />
        <path d="M155.83 58.9204H184.7L187.58 48.1904H158.72L155.84 58.9204H155.83Z" fill="black" />
        <path
            d="M299.899 68.9298H263.589L274.619 27.7598H263.879L252.729 69.3598C251.249 74.8798 254.529 79.3598 260.049 79.3598H307.839L321.669 27.7598H310.929L299.899 68.9298Z"
            fill="black"
        />
        <path
            d="M435.669 58.9698C441.189 58.9698 446.869 54.4898 448.349 48.9698L451.349 37.7598C452.829 32.2398 449.549 27.7598 444.029 27.7598H396.069L393.189 38.4998H440.579L437.969 48.2298H390.579L382.239 79.3598H392.699L398.159 58.9698H411.849L426.769 79.3598H441.989L427.069 58.9698H435.659H435.669Z"
            fill="black"
        />
        <path
            d="M502.379 27.7598H462.539L448.709 79.3598H488.549C498.489 79.3598 508.699 71.2998 511.369 61.3698L515.549 45.7598C518.209 35.8198 512.319 27.7698 502.379 27.7698V27.7598ZM501.129 60.6098C499.949 65.0298 495.409 68.6098 490.989 68.6098H462.039L470.099 38.5098H499.049C503.469 38.5098 506.089 42.0898 504.899 46.5098L501.119 60.6098H501.129Z"
            fill="black"
        />
        <path
            d="M215.219 27.7599C205.279 27.7599 195.069 35.82 192.399 45.75L188.219 61.36C185.559 71.3 191.449 79.35 201.389 79.35H241.229L249.569 48.24H239.129L233.669 68.6H204.719C200.299 68.6 197.679 65.02 198.869 60.6L202.649 46.5C203.829 42.08 208.369 38.5 212.789 38.5H252.179L255.059 27.75H215.219V27.7599Z"
            fill="black"
        />
        <path d="M353.369 27.7598L312.709 79.3598H324.539L355.609 39.9298L365.559 79.3598H377.389L364.369 27.7598H353.369Z" fill="black" />
        <defs>
            <linearGradient id="paint0_linear_2337_661" x1="141.37" y1="-5.3" x2="-3.68975" y2="121.45" gradientUnits="userSpaceOnUse">
                <stop stopColor="#E7BE2D" />
                <stop offset="1" stopColor="#A67517" />
            </linearGradient>
        </defs>
    </svg>
);

export const IconX4 = (
    <svg width="52" height="12" viewBox="0 0 52 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M33.5195 7.34078H34.6909L36.2385 1.5625H35.0683L33.5195 7.34078Z" fill="black" />
        <path
            d="M23.6367 4.77303H22.1092L22.8875 6.13697H20.1843C20.1283 6.1402 20.0744 6.11487 20.0412 6.06966C20.008 6.02445 19.9999 5.9655 20.0197 5.913L20.8035 2.99027C20.8412 2.86326 20.9546 2.77362 21.0869 2.76631H24.7823C24.8381 2.76347 24.8916 2.78896 24.9246 2.83411C24.9575 2.87925 24.9655 2.93797 24.9458 2.99027L24.4922 4.68344L25.2851 6.07202C25.2929 6.04738 25.3019 6.02275 25.3086 5.99811L26.1373 2.90629C26.3366 2.16384 25.8954 1.5625 25.1541 1.5625H21.3646C20.6233 1.5625 19.8607 2.16384 19.6613 2.90629L18.8327 5.99811C18.6345 6.73943 19.0745 7.3419 19.8159 7.3419H25.107L23.6367 4.77303Z"
            fill="black"
        />
        <path
            d="M31.5137 6.17671H27.4487L28.6805 1.56641H27.4767L26.2292 6.22486C26.0635 6.84412 26.4308 7.34468 27.0489 7.34468H32.4006L33.9493 1.56641H32.7455L31.5137 6.17671Z"
            fill="black"
        />
        <path d="M51.1511 1.5625H44.6663L44.3438 2.76407H47.0011L45.7749 7.34078H46.9462L48.1724 2.76407H50.8298L51.1511 1.5625Z" fill="black" />
        <path d="M35.8086 7.34044H42.28L42.6014 6.14111H37.3013L37.5925 5.05152H42.8937L43.2151 3.85107H36.7437L35.8086 7.34044Z" fill="black" />
        <path d="M37.0352 2.76295H43.5066L43.828 1.5625H37.3566L37.0352 2.76295Z" fill="black" />
        <path d="M14.6777 5.05704H17.9107L18.232 3.85547H15.0002L14.6777 5.05704Z" fill="black" />
        <path d="M7.8848 0H4.625L7.47271 3.85218L9.55109 2.25756L7.8848 0Z" fill="black" />
        <path d="M11.2068 8.90378H14.4666L11.8541 5.36963L9.60547 6.73693L11.2068 8.90378Z" fill="black" />
        <path d="M17.4524 0H13.3572L6.2766 5.43225H7.82643L0 12L13.4076 3.85666H11.8399L17.4524 0Z" fill="url(#paint0_linear_4848_33875)" />
        <defs>
            <linearGradient id="paint0_linear_4848_33875" x1="16.4871" y1="-7.66165e-08" x2="0.0204384" y2="11.9804" gradientUnits="userSpaceOnUse">
                <stop stopColor="#EAC64C" />
                <stop offset="0.554786" stopColor="#C09325" />
                <stop offset="1" stopColor="#AF7D14" />
            </linearGradient>
        </defs>
    </svg>
);

export const IconInfo = (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 19.5H11V15.5H18V11.5H22V19.5H19.5L18 21L16.5 19.5Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 3.5H18V15.5H8.5L6.5 17.5L4.5 15.5H2V3.5Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 11.5H9" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
        <path d="M6 7.5H12" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
);

export const Icondp = (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.875 4.93434L11.5041 2.41602L20.125 4.93434V10.0988C20.125 15.5271 16.6511 20.3461 11.5012 22.0621C6.34996 20.3462 2.875 15.526 2.875 10.0964V4.93434Z"
            stroke="black"
            strokeWidth="1.3"
            strokeLinejoin="round"
        />
        <path
            d="M11.402 16.68C10.962 16.68 10.552 16.59 10.172 16.41C9.792 16.226 9.464 15.974 9.188 15.654C8.916 15.334 8.72 14.962 8.6 14.538L9.992 14.166C10.048 14.398 10.15 14.598 10.298 14.766C10.45 14.934 10.626 15.064 10.826 15.156C11.03 15.248 11.24 15.294 11.456 15.294C11.736 15.294 11.992 15.226 12.224 15.09C12.456 14.954 12.64 14.772 12.776 14.544C12.912 14.312 12.98 14.056 12.98 13.776C12.98 13.496 12.91 13.242 12.77 13.014C12.634 12.782 12.45 12.6 12.218 12.468C11.986 12.332 11.732 12.264 11.456 12.264C11.124 12.264 10.848 12.324 10.628 12.444C10.412 12.564 10.246 12.692 10.13 12.828L8.894 12.432L9.158 7.86H13.85V9.216H9.932L10.472 8.706L10.28 11.886L10.016 11.562C10.24 11.358 10.5 11.206 10.796 11.106C11.092 11.006 11.378 10.956 11.654 10.956C12.194 10.956 12.672 11.08 13.088 11.328C13.508 11.572 13.836 11.906 14.072 12.33C14.312 12.754 14.432 13.236 14.432 13.776C14.432 14.316 14.292 14.806 14.012 15.246C13.732 15.682 13.362 16.03 12.902 16.29C12.446 16.55 11.946 16.68 11.402 16.68Z"
            fill="black"
        />
    </svg>
);
